import { Typography, TypographyProps } from '@mui/material';
import { ReactNode } from 'react';

import { ColorOptions } from './Text.styles';
import { useStyles } from './Text.styles';

interface TextProps extends Omit<TypographyProps, 'color'> {
  children: ReactNode;
  color?: ColorOptions;
  paragraph?: boolean;
}

const variantToColorMap: {
  [key: string]: ColorOptions;
} = {
  h1: 'textDark',
  h2: 'textDark',
  h3: 'textWhite',
  h5: 'textDarkGray',
  subTitle1: 'textDark',
  body1: 'textPrimary',
  body2: 'textSecondary',
  caption: 'textPrimary',
  default: 'textPrimary',
};

export const Text = ({
  variant,
  color,
  classes,
  children,
  paragraph,
  ...props
}: TextProps) => {
  const styles = useStyles({
    color: color || variantToColorMap[variant || 'default'],
  });
  if (paragraph) {
    return (
      <p>
        <Typography
          variant={variant}
          classes={{ ...styles, ...classes }}
          {...props}
        >
          {children}
        </Typography>
      </p>
    );
  }

  return (
    <Typography
      variant={variant}
      classes={{ ...styles, ...classes }}
      {...props}
    >
      {children}
    </Typography>
  );
};
